import { render, staticRenderFns } from "./TeamGridV2.vue?vue&type=template&id=3e0764da&scoped=true&"
import script from "./TeamGridV2.vue?vue&type=script&lang=js&"
export * from "./TeamGridV2.vue?vue&type=script&lang=js&"
import style0 from "./TeamGridV2.vue?vue&type=style&index=0&id=3e0764da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0764da",
  null
  
)

export default component.exports